import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Text, Margin, Panel, Link } from 'shared/components'
import { InWinImage } from 'routes/shared/components'
import { athlete as athleteRoutes } from 'routes/route.map'

import { AthleteCard } from '../athleteCard'

import * as styles from './styles'

const renderAthlete = (athlete) => (
  <li key={athlete.id}>
    <Link
      title={`${athlete.name} ${athlete.surname}`}
      to={athleteRoutes.view(athlete.id)}
    >
      <AthleteCard athlete={athlete} />
    </Link>
  </li>
)

const TeamDetailsPanelComponent = ({ team, athletes }) => (
  <>
    <Margin bottom={2}>
      <Panel>
        <main>
          <Grid>
            <Row>
              <Col xs={8}>
                <Margin bottom={2} css={styles.header}>
                  {team?.jurisdiction?.logo && (
                    <Margin right={2}>
                      <InWinImage
                        source={team?.jurisdiction?.logo}
                        alt={team?.jurisdiction?.logo}
                        css={styles.flag}
                      />
                    </Margin>
                  )}
                  <Text as="h1" size={20} bold>
                    {team?.teamName}
                  </Text>
                </Margin>
                <Margin tb={1}>
                  <Text>Jurisdiction: </Text>
                  <Text bold>{team?.jurisdiction?.name}</Text>
                </Margin>
                <Margin tb={1}>
                  <Text>Members Count: </Text>
                  <Text bold>{team?.athletes?.length}</Text>
                </Margin>
                <Margin tb={1}>
                  <Link as="a" href={team?.teamWebsite}>
                    {team?.teamWebsite}
                  </Link>
                </Margin>
              </Col>
              <Col xs={4}>
                <div css={styles.logoWrapper}>
                  {team?.logo && (
                    <InWinImage
                      source={team?.logo}
                      alt={team?.logo}
                      css={styles.logo}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Grid>
        </main>
      </Panel>
    </Margin>
    <Panel>
      <main>
        <Margin bottom={2} css={styles.header}>
          <Text as="h1" size={20} bold>
            Athletes
          </Text>
        </Margin>
        <ul css={styles.athleteList}>{athletes?.map(renderAthlete)}</ul>
      </main>
    </Panel>
  </>
)

TeamDetailsPanelComponent.propTypes = {
  team: PropTypes.shape(),
  athletes: PropTypes.arrayOf(PropTypes.shape()),
}

export default TeamDetailsPanelComponent
